var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56.6,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 56.6,
    rx: 2.28571,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3118 22.7302H18.1161L20.1149 11.1296H23.3105L21.3118 22.7302Z",
    fill: "#15195A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8963 11.4133C32.266 11.1786 31.2662 10.9194 30.03 10.9194C26.8741 10.9194 24.6518 12.499 24.6382 14.7573C24.612 16.4235 26.2293 17.3489 27.439 17.9045C28.6753 18.4722 29.0956 18.8427 29.0956 19.3487C29.083 20.1259 28.0965 20.4841 27.1765 20.4841C25.9006 20.4841 25.217 20.2994 24.1781 19.8671L23.7573 19.6817L23.3101 22.2858C24.0596 22.6063 25.4405 22.8907 26.8742 22.9032C30.2273 22.9032 32.4103 21.3481 32.4362 18.9415C32.449 17.6209 31.5949 16.609 29.7537 15.7822C28.636 15.2514 27.9515 14.8935 27.9515 14.3504C27.9646 13.8567 28.5305 13.351 29.7922 13.351C30.8311 13.3262 31.5944 13.5606 32.1727 13.7951L32.4617 13.9183L32.8963 11.4133V11.4133V11.4133Z",
    fill: "#15195A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6168 11.1296H41.0886L43.6668 22.7301H40.7079C40.7079 22.7301 40.4183 21.3972 40.3265 20.9899H36.2235C36.1049 21.2983 35.5528 22.7301 35.5528 22.7301H32.1996L36.9465 12.0921C37.2754 11.3393 37.8545 11.1296 38.6168 11.1296ZM38.4199 15.3748C38.4199 15.3748 37.4072 17.9542 37.144 18.6206H39.8002C39.6688 18.0406 39.0637 15.2638 39.0637 15.2638L38.8403 14.2642C38.7463 14.5216 38.6103 14.8755 38.5185 15.1142C38.4563 15.276 38.4145 15.3849 38.4199 15.3748Z",
    fill: "#15195A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26952 11.1296H9.41111C10.108 11.1541 10.6735 11.3639 10.8575 12.1048L11.9749 17.4346C11.975 17.435 11.9752 17.4354 11.9753 17.4359L12.3173 19.0402L15.447 11.1297H18.8262L13.8031 22.718H10.4237L7.57532 12.6381C6.59256 12.0988 5.47095 11.665 4.21692 11.364L4.26952 11.1296Z",
    fill: "#15195A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.b803dc65c19bcb1d9b9d0161af3d678f.svg";
export { ForwardRef as ReactComponent };